/* eslint-disable no-unused-vars */
import apisauce from 'apisauce';

const ADAPTER = 'webwidget';
const HTTP_SERVER_ROOT = process.env.REACT_APP_API_URL;

const create = () => {
  const api = apisauce.create({
    baseURL: `${HTTP_SERVER_ROOT}webhook/${ADAPTER}/`,
    withCredentials: true,
    timeout: 60 * 1000,
  });

  const message = (function messageAPI() {
    return {
      send: ({ webhook, data }) => api.post(`${webhook}/`, data),
    };
  }());

  return {
    message,
  };
};

export default {
  create,
};
